<template>
    <div class="chart-one">
        <h1>中美最佳安全防范措施部署率对比</h1>
          <div class="box-item">
              <div v-for="(item,index) in compareList" :key="index">
              <div class="square-region">
                  <div class="blue-part">
                      <div class="bottom-decorate"></div>
                      <div class="medium-part" :style="getMediumStyle(item.cn_rate * 100)"></div>
                      <div class="top-part" :style="getTopStyle(item.cn_rate * 100)"></div>
                      <div class="decorate-part" :style="getDecorateStyle(item.cn_rate * 100)"></div>
                      <div class="score-part" :style="getScoreTextStyle(item.cn_rate * 100)">{{item.cn_rate * 1000 / 10}}</div>
                  </div>
                  <div class="green-part">
                      <div class="bottom-decorate"></div>
                      <div class="medium-part" :style="getMediumStyle(item.us_rate * 100)"></div>
                      <div class="top-part" :style="getTopStyle(item.us_rate * 100)"></div>
                      <div class="decorate-part" :style="getDecorateStyle(item.us_rate * 100)"></div>
                      <div class="score-part" :style="getScoreTextStyle(item.us_rate * 100)">{{item.us_rate * 1000 / 10}}</div>
                  </div>
              </div>
              <div class="item-text"><span>{{item.prac_name}}</span><span style="margin-left: 5px">{{item.prac_type}}</span></div>
                  </div>
          </div>
        <div class="legend-box">
            <div class="legend-item">
                <div class="china-icon"></div>
                <div class="legend-text">中国</div>
            </div>
            <div class="legend-item">
                <div class="us-icon"></div>
                <div class="legend-text">美国</div>
            </div>
        </div>

      </div>
</template>
<script>
import {getBestPractices} from "@/service/dashboard";

export default {
  data() {
    return {
      compareList: [
        {cn_rate: 0.995, prac_name: "DNSSEC", prac_type: "DOMAIN", us_rate: 0.994},
        {cn_rate: 0.192, prac_name: "SPF", prac_type: "Email Record", us_rate: 0.842},
        {cn_rate: 0.072, prac_name: "PKI", prac_type: "TLSv1.3", us_rate: 0.545}
      ]
    };
  },
  mounted() {

    this.getData();
  },
  methods: {
    getData(){
      getBestPractices().then(res => {
        this.compareList = res;
      });
    },
    getMediumStyle(num) {
      return {
        "height": num / 90.8 * 115 / 192 + "rem",
        "backgroundSize": `0.10417rem ${num / 90.8 * 115 / 192}rem`
      };
    },
    getTopStyle(num) {
      return {
        "bottom": (num / 90.8 * 115 + 1) / 192 + "rem"
      };
    },
    getDecorateStyle(num) {
      return {
        "bottom": (num / 90.8 * 115 + 10) / 192 + "rem"
      };
    },
    getScoreTextStyle(num) {
      return {
        "bottom": (num / 90.8 * 115 + 21) / 192 + "rem"
      };
    }
  }

};
</script>
<style scoped lang="less">
.chart-one {
    width: 100%;
    height: 100%;
    border-radius: 10px;
    background: linear-gradient(to right, rgba(73, 74, 98, 0.3), rgba(108, 111, 157, 0.2));
    box-sizing: border-box;
    padding-left: 36px;
    padding-top: 15px;
    position: relative;
}
h1{
  color: rgba(241, 237, 255, 1);
  font-family: 'YouSheBiaoTiHei';
  font-size: 24px;
  height: 31px;
  //position: absolute;
  text-shadow: 0 2px 20px rgba(42, 56, 180, 1);
    text-align: left;
}
.box-item {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    padding-right: 80px;
    .square-region {
        //width: 78px;
        height: 160px;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        .blue-part,.green-part {
            width: 35px;
            height: 155px;
            position: relative;
        }
        .bottom-decorate {
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 30px;
            height: 60px;
            background-image: url("../../assets/action/bottom-decorate.png");
            background-size: 100%;
        }
        .medium-part {
            position: absolute;
            bottom: 9px;
            left: 50%;
            transform: translateX(-50%);
            width: 20px;
            height: 115px;
            background-image: url("../../assets/action/medium-part.png");
            background-size: 100%;
            background-repeat: no-repeat;
        }
        .top-part {
            position: absolute;
            bottom: 116px;
            left: 50%;
            transform: translateX(-50%);
            width: 20px;
            height: 19px;
            background-image: url("../../assets/action/top-part.png");
            background-size: 100%;
        }
        .decorate-part {
            position: absolute;
            bottom: 125px;
            left: 50%;
            transform: translateX(-50%);
            width: 30px;
            height: 31px;
            background-image: url("../../assets/action/decorate.png");
            background-size: 100%;
        }
        .score-part {
            height: 18px;
            line-height: 18px;
            font-family: YouSheBiaoTiHei;
            font-size: 14px;
            position: absolute;
            bottom: 136px;
            left: 50%;
            transform: translateX(-50%);
            color: #FFF;
        }
        .green-part {
            .bottom-decorate {
                background-image: url("../../assets/action/green-bottom-decorate.png");
            }
            .medium-part {
                background-image: url("../../assets/action/green-medium-part.png");
            }
            .top-part {
                background-image: url("../../assets/action/green-top-part.png");
            }
            .decorate-part {
                background-image: url("../../assets/action/green-decorate.png");
            }
        }
    }
    .item-text {
        margin-top: 8px;
        //width: 78px;
        height: 18px;
        line-height: 18px;
        font-size: 12px;
        font-family: 'AlibabaRegular';
        font-weight: 500;
        background-color: #9AAAE433;
        color: #FFF;
    }
}
.legend-box {
    position: absolute;
    top: 50px;
    left: 350px;
    .legend-item {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
        .legend-text {
            font-size: 14px;
            color: #fff;
            margin-left: 10px;
            font-family: 'SourceHanSansCN';
        }
        .china-icon {
            background: linear-gradient(180deg, #4356FF 0%, #5D96FF 100%);
            width: 15px;
            height: 15px;
        }
        .us-icon {
            background: linear-gradient(180deg, #5FF6DB 0%, #3AB8C0 100%);
            width: 15px;
            height: 15px;
        }

    }
}
</style>